import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "proFilled"
const ProFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.435 10.475C18.306 10.475 18.866 11.187 18.866 12.337V12.345C18.867 13.486 18.32 14.21 17.435 14.21 16.567 14.21 16.01 13.5 16.01 12.345V12.337C16.01 11.183 16.57 10.475 17.435 10.475M5.95 10.488C6.601 10.488 6.99 10.825 6.99 11.457V11.465C6.99 12.096 6.602 12.438 5.95 12.438H5.275V10.488zM11.517 10.47C12.06 10.47 12.423 10.809 12.423 11.318V11.327C12.423 11.84 12.073 12.167 11.525 12.167H10.611V10.471z" />
          <path
            fillRule="evenodd"
            d="M21.002 1.5C21.831 1.5 22.5 2.172 22.5 3V21C22.5 21.828 21.828 22.5 21 22.5H3C2.172 22.5 1.5 21.828 1.5 21V3C1.5 2.172 2.17 1.5 2.998 1.5zM17.435 9.195C15.598 9.195 14.436 10.404 14.436 12.337V12.345C14.436 14.282 15.59 15.491 17.435 15.491 19.287 15.49 20.437 14.282 20.437 12.345V12.337C20.437 10.404 19.283 9.195 17.435 9.195M3.729 9.305V15.382H5.276V13.6H6.32C7.676 13.6 8.552 12.766 8.552 11.465V11.457C8.552 10.155 7.676 9.305 6.32 9.305zM9.066 9.305V15.382H10.61V13.288H11.4L12.444 15.382H14.179L12.962 13.057C13.593 12.783 13.997 12.109 13.997 11.33V11.322C13.997 10.033 13.167 9.305 11.698 9.305z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ProFilledIcon
